import TextEditor from "./editor"

export default TextEditor
